import { DocumentServiceFactory } from '@/resources/factory';

const accountDocumentService = new DocumentServiceFactory({
  getAll: 'api/AccountDocument/:id',
  uploadFiles: 'api/AccountDocument/uploadfiles/:id',
  deleteDocument: 'api/AccountDocument/:id',
  openDocument: 'api/AccountDocument/download?fileId=:id',
})

export default accountDocumentService;
